import ContentLoader, { Rect } from "react-content-loader/native";
import { VStack } from "@gluestack-ui/themed";

export const TransactionsLoading = () => {
  return (
    <>
      <VStack mx="$2" width="100%" my="$2">
        <ContentLoader backgroundColor="#CDCDCD">
          <Rect x="0" y="0" rx="8" ry="8" height="18" width="30%" />
          <Rect x="0" y="30" rx="8" ry="8" height="210" width="99%" />
        </ContentLoader>
      </VStack>
      <VStack mx="$2" width="100%" my="$2">
        <ContentLoader backgroundColor="#CDCDCD">
          <Rect x="0" y="0" rx="8" ry="8" height="18" width="30%" />
          <Rect x="0" y="30" rx="8" ry="8" height="210" width="99%" />
        </ContentLoader>
      </VStack>
      <VStack mx="$2" width="100%" my="$2">
        <ContentLoader backgroundColor="#CDCDCD">
          <Rect x="0" y="0" rx="8" ry="8" height="18" width="30%" />
          <Rect x="0" y="30" rx="8" ry="8" height="210" width="99%" />
        </ContentLoader>
      </VStack>
    </>
  );
};
